<!-- *ngIf="!(isError || hasAutoLiabilityAvailable)"  -->
<div class="bl-bg-color--snow-light bl-border-radius--6 bl-padding--24">
  <h2 class="bl-font-weight--900 bl-font-color--black bl-font-size--28">
    {{'appPrefill/title' | dictionary}}
  </h2>
  <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'appPrefill/subtitle' | dictionary"></p>

  <ng-container *ngIf="callStatusMsg">
    <p class="bl-margin-y--24 bl-font-color--steel">{{callStatusMsg}}</p>
  </ng-container>

  <div class="bl-row bl-no-gutters">
    <div class="bl-select-wrap bl-width--100 bl-width-sm--auto bl-margin-right-sm--24 bl-margin-bottom--16 bl-margin-bottom-sm--0 bl-display--flex bl-align-items--center">
      <select class="bl-select bl-input" id="prefilTypeId" [(ngModel)]="selectedPrefillType" (change)="onChangePrefillType()" required>
        <option *ngFor="let option of preFillOptions" [value]="option.value">{{option.label}}</option>
      </select>
    </div>

    <button class="bl-button bl-button-reverse bl-border--primary bl-width--100 bl-width-sm--auto" id="btn-prefill"
      (click)="appAutofill()">
      <!-- [disabled]="invalidAuthorization" -->
      <span class=" bl-font-color--slate bl-font-size--14 bl-font-weight--700">
        {{'appPrefill/ctaText' | dictionary}}
      </span>
    </button>
  </div>

  <ng-container *ngIf="isLoading">
    <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'appPrefill/loadingText' | dictionary"></p>
    <ecp-content-spinner></ecp-content-spinner>
  </ng-container>
</div>
